export default __webpack_public_path__ + "static/media/credenciadoWeb.550b5974.png";